<script>
import ContentTree from '@/components/lessons/ContentTree.vue';
export default { name: 'contents', components: { ContentTree } };
</script>
<template>
  <main class="contents-page" dir="rtl">
    <header><h1>محتوى الحصص</h1><p>تصفح الفروع والوحدات، ثم افتح الدرس الذي تريد مشاهدته.</p></header>
    <ContentTree />
  </main>
</template>
<style scoped>
.contents-page { width: 100%; max-width: 1160px; min-width: 0; margin: auto; padding: 1.5rem 1rem 6rem; overflow-wrap: anywhere; }
header { margin-bottom: 1.5rem; }
h1 { font-size: clamp(1.5rem, 4vw, 2.2rem); }
@media (max-width: 600px) { .contents-page { padding-inline: .6rem; } }
</style>
